import { render, staticRenderFns } from "./SlideInBaseTemplate.vue?vue&type=template&id=bc475582&scoped=true&lang=pug&functional=true&"
var script = {}
import style0 from "./SlideInBaseTemplate.vue?vue&type=style&index=0&id=bc475582&scoped=true&lang=stylus&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  true,
  null,
  "bc475582",
  null
  
)

export default component.exports